export const Marquee = () => {
  const phrase = "ONE DROP. ALL VIBE. NO LABELS.";
  const items = Array.from({ length: 12 }, (_, i) => phrase);
  return (
    <section
      data-testid="marquee"
      className="relative overflow-hidden border-y border-[#333] py-6"
    >
      <div className="flex whitespace-nowrap marquee-track">
        {items.concat(items).map((p, i) => (
          <span
            key={i}
            className={`font-display mx-6 text-5xl leading-none md:text-7xl ${i % 2 === 0 ? "" : "text-outline"}`}
          >
            {p}
            <span className="mx-6 text-[#555]">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
